import React, { Component } from 'react';
import {
  Container,
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { toast } from 'react-toastify';

import { FaPhone, FaSpinner } from 'react-icons/fa';
import LoadingComponent from '../common/LoadingComponent';
import ResultToast from '../revamp-offline-ops/ResultToast';
import { BoldText } from '../common/Text';
import { callUserVisionRequest, fetchVisionRequestDetails, getVisionRequestComments, updateCashlessSentStatus } from '../../services/api/cashless-vision';
import CommentList from './visionCommentList';
import CommentForm from './visionCommentForm';
import { getBlobUrl } from '../../utils/getBlobUrlAndContentType';

const DetailsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const SectionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const SectionInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.625rem;
`;

const SectionHeader = styled(BoldText)`
  font-size: 1.2rem;
  color: #4b4f5b;
`;

const SectionBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 0.625rem;
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 0.25rem;
`;

const DetailName = styled.div`
  font-size: 1rem;
  width: ${(props) => (props.fullWidth ? '20rem' : '8rem')};
  color: #4c4c4c;
`;

const DetailText = styled.div`
  flex: 1;
  font-size: 1rem;
  color: ${(props) => props.color || '#787778'};
  margin-left: 0.25rem;
`;

const DetailTextDanger = styled.div`
  font-size: 1rem;
  color: #ff4d48;
`;

const CallUserText = styled.div`
  font-size: 1rem;
  margin-left: 0.4rem;
  color: #56c02c;
  cursor: pointer;
`;

const SpocDetailContainer = styled(SectionContainer)`
  background-color: #f8f9fa;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  padding: 0.625rem;
`;

// Component to load and display blob images
class BlobImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blobUrl: null,
      loading: true,
      error: false
    };
  }

  componentDidMount() {
    this.loadBlobUrl();
  }

  componentWillUnmount() {
    // Cleanup blob URL to prevent memory leaks
    if (this.state.blobUrl) {
      URL.revokeObjectURL(this.state.blobUrl);
    }
  }

  loadBlobUrl = async () => {
    try {
      const blobUrl = await getBlobUrl(this.props.url);
      this.setState({ blobUrl, loading: false });
    } catch (error) {
      console.error('Error loading blob URL:', error);
      this.setState({ error: true, loading: false });
    }
  };

  render() {
    const { blobUrl, loading, error } = this.state;
    const { alt } = this.props;

    return (
      <div
        style={{
          width: '100%',
          height: '90px',
          backgroundColor: '#F8F9FA',
          borderRadius: '6px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {loading && (
          <FaSpinner
            size={24}
            style={{ color: '#714FFF' }}
            className="icon-spin"
          />
        )}
        {!loading && !error && blobUrl && (
          <img
            src={blobUrl}
            alt={alt}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            onError={() => this.setState({ error: true })}
          />
        )}
        {!loading && error && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              fontSize: '2.5rem',
            }}
          >
            <span role="img" aria-label="Document file">
              📄
            </span>
          </div>
        )}
      </div>
    );
  }
}

class RequestDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      callUserLoading: false,
      showToast: false,
      callRequest: false,
      loading: false,
      details: {},
      requestDetails: {},
      preAuthItemDetails: [],
      spocDetails: [],
      paymentDetails: [],
      comments: [],
      showConfirmationModal: false,
      activeInfo: 'basic',
      selectedCallReason: null,
      isCallModalOpen: false,
      callReasonOptions: [
        'Reminder for copayment',
        'Reminder to upload vision card',
        'Issues in ordered items/ prices',
        'Issues in invoice details',
        'An update',
      ],
      cashlessSentStatus: false,
      visionCardInfo: []
    };

    this.addComment = this.addComment.bind(this);
  }

  componentDidMount() {
    this.getCashlessVisionRequest();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.requestDetails !== this.state.requestDetails) {
      this.props.sendDataToParent(this.state.requestDetails);
    }
  };

  getCashlessVisionRequest = () => {
    const { requestId } = this.props.cashlessVision;
    let resBody = {};
    fetchVisionRequestDetails(requestId)
      .then((responseBody) => {
        resBody.details = responseBody;
        const {
          requestDetails,
          preAuthItemDetails,
          spocDetails,
          visionTransactionDetails,
          visionCardInfo
        } = responseBody;
        this.setState({
          requestDetails,
          preAuthItemDetails,
          spocDetails,
          paymentDetails: visionTransactionDetails || [],
          cashlessSentStatus: requestDetails.cashlessSentStatus === 1,
          visionCardInfo: visionCardInfo || []
        });
      })
      .then(() => getVisionRequestComments(requestId))
      .then(this.handleComments)
      .then((comments) => {
        this.setState({
          details: resBody.details,
          comments,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleComments = (response) => {
    const comments = [];
    if (response.message === 'success' && response.data.length) {
      response.data.forEach((c) => {
        comments.push({
          name: c.userName,
          message: c.comment,
          time: c.createdAt,
        });
      });
    }
    return comments;
  };

  addComment(comment) {
    this.setState({
      loading: false,
      comments: [...this.state.comments, comment],
    });
  }

  initiateCall = () => {
    this.setState({
      callUserLoading: true,
      showConfirmationModal: true,
      isCallModalOpen: true,
    });
  };

  handleCallReasonChange = (event) => {
    const { value } = event.target;
    this.setState({
      selectedCallReason: value,
      callUserLoading: false // Reset loading state when reason changes
    });
  };

  submitCall = async () => {
    const { requestId } = this.props.cashlessVision;
    const { selectedCallReason } = this.state;

    if (!selectedCallReason) {
      toast.error('Please select a reason for calling');
      return;
    }

    try {
      this.setState({ callUserLoading: true });
      await callUserVisionRequest(requestId, selectedCallReason);
      toast.success('Call initiated successfully');
      this.setState({
        showConfirmationModal: false,
        isCallModalOpen: false,
        selectedCallReason: null,
        callUserLoading: false
      });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to initiate call');
      this.setState({ callUserLoading: false });
    }
  };

  showSuccessToast(successToastMessage) {
    this.setState(
      {
        successToastMessage: successToastMessage,
        callRequest: true,
        showToast: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showToast: false,
            callRequest: false,
          });
        }, 3000);
      }
    );
  }

  showFailureToast(errorDesc) {
    this.setState(
      {
        failRequest: true,
        showToast: true,
        errorDesc,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showToast: false,
            failRequest: true,
            errorDesc: null,
          });
        }, 3000);
      }
    );
  }

  toggleToast = () => {
    this.setState({
      showToast: false,
    });
  };

  handleCashlessSentStatusChange = async (event) => {
    const { requestId } = this.props.cashlessVision;
    const isChecked = event.target.checked;

    try {
      await updateCashlessSentStatus(requestId);
      this.setState({ cashlessSentStatus: isChecked });
      toast.success(`Cashless sent status updated successfully`);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update status');
    }
  };

  renderPaymentInfo = () => {
    const { paymentDetails, preAuthItemDetails } = this.state;

    // Get the first payment detail object from array
    const paymentDetail = paymentDetails && paymentDetails.length > 0 ? paymentDetails[0] : {};
    return (
      <DetailsContainer
        style={{
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        {/* Payment Details Section */}
        <SectionContainer>
          <SectionInnerContainer>
            <SectionHeader
              style={{
                borderBottom: '1px solid #F2F1F6',
                padding: '8px',
              }}
            >
              Payment Details
            </SectionHeader>
            <SectionBody
              style={{
                paddingTop: '8px',
              }}
            >
              <DetailRow>
                <DetailName>Total Amount:</DetailName>
                <DetailText>
                  {paymentDetail.totalAmount ? `₹${paymentDetail.totalAmount}` : (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Wallet Deduction:</DetailName>
                <DetailText>
                  {paymentDetail.walletDeduction ? `₹${paymentDetail.walletDeduction}` : (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Copay:</DetailName>
                <DetailText>
                  {paymentDetail.copay ? `₹${paymentDetail.copay}` : (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Transaction Time:</DetailName>
                <DetailText>
                  {paymentDetail.transactionTime || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Total Refund Amount:</DetailName>
                <DetailText>
                  {paymentDetail.refundAmount || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Total Copay Refund Amount:</DetailName>
                <DetailText>
                  {paymentDetail.copayRefundAmount || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
            </SectionBody>
          </SectionInnerContainer>
        </SectionContainer>

        {/* Payment Items Table Section */}
        <SectionContainer>
          <SectionInnerContainer>
            <SectionHeader
              style={{
                borderBottom: '1px solid #F2F1F6',
                padding: '8px',
              }}
            >
              Payment Items
            </SectionHeader>
            <SectionBody
              style={{
                paddingTop: '8px',
              }}
            >
              {preAuthItemDetails && preAuthItemDetails.length > 0 ? (
                <div style={{ overflowX: 'auto' }}>
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      fontSize: '14px',
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: '#F8F9FA',
                          borderBottom: '2px solid #E0E0E0',
                        }}
                      >
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Item Name
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Cost
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Copay
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Wallet Deduction
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Approved Amount
                        </th>
                        {/* <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Total Price
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Discount
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Quantity
                        </th> */}
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Remarks
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', color: '#4B4F5B', fontWeight: '600' }}>
                          Doctor Remarks
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {preAuthItemDetails.map((item, index) => (
                        <tr
                          key={index}
                          style={{
                            borderBottom: '1px solid #E0E0E0',
                          }}
                        >
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.itemName || 'N/A'}
                          </td>
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.cost ? `₹${item.cost}` : 'N/A'}
                          </td>
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.copay ? `₹${item.copay}` : 'N/A'}
                          </td>
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.walletDeduction ? `₹${item.walletDeduction}` : 'N/A'}
                          </td>
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.approvedAmount ? `₹${item.approvedAmount}` : 'N/A'}
                          </td>
                          {/* <td style={{ padding: '12px', color: '#787778' }}>
                            {item.totalPrice ? `₹${item.totalPrice}` : 'N/A'}
                          </td>
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.discount ? `₹${item.discount}` : 'N/A'}
                          </td>
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.quantity || 'N/A'}
                          </td> */}
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.remarks || 'N/A'}
                          </td>
                          <td style={{ padding: '12px', color: '#787778' }}>
                            {item.drRemarks || 'N/A'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <DetailTextDanger style={{ padding: '12px' }}>
                  No payment items available
                </DetailTextDanger>
              )}
            </SectionBody>
          </SectionInnerContainer>
        </SectionContainer>
      </DetailsContainer>
    );
  };

  renderActionInfo = () => {
    const { requestDetails } = this.state;
    const requestStatus = requestDetails.requestStatus;

    // Determine button states based on request status
    const isPaymentComplete = requestStatus === 'payment-complete';
    const isCompleted = requestStatus === 'completed';
    const showBothButtons = isPaymentComplete;
    const disableBothButtons = !isPaymentComplete && !isCompleted;

    return (
      <DetailsContainer
        style={{
          flexDirection: 'column',
          gap: '20px',
          padding: '20px',
        }}
      >
        <SectionContainer>
          <SectionHeader
            style={{
              fontSize: '1.5rem',
              marginBottom: '20px',
            }}
          >
            Cashless Letter
          </SectionHeader>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              alignItems: 'center',
              padding: '30px',
              backgroundColor: '#F8F9FA',
              borderRadius: '8px',
            }}
          >
            <Button
              onClick={async () => {
                if (requestDetails.cashlessLetter) {
                  try {
                    const response = await fetch(requestDetails.cashlessLetter);
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl, '_blank');
                  } catch (error) {
                    console.error('Error opening cashless letter:', error);
                    toast.error('Failed to open cashless letter');
                  }
                } else {
                  toast.error('Cashless letter link not available');
                }
              }}
              disabled={disableBothButtons}
              style={{
                width: '100%',
                maxWidth: '400px',
                height: '48px',
                backgroundColor: disableBothButtons ? '#CCCCCC' : '#5DADE2',
                border: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: disableBothButtons ? 'not-allowed' : 'pointer',
                opacity: disableBothButtons ? 0.6 : 1,
              }}
            >
              Preview Cashless Letter
            </Button>

            <Button
              onClick={async () => {
                const { requestId } = this.props.cashlessVision;
                try {
                  // Ensure updateCashlessSentStatus accepts (requestId, status)
                  await updateCashlessSentStatus(requestId);
                  toast.success('Cashless letter resent successfully');
                } catch (error) {
                  toast.error(error.response?.data?.message || 'Failed to resend cashless letter');
                }
              }}
              disabled={!showBothButtons}
              style={{
                width: '100%',
                maxWidth: '190px',
                height: '45px',
                backgroundColor: !showBothButtons ? '#CCCCCC' : '#28A745',
                border: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                marginTop: '15px',
                cursor: !showBothButtons ? 'not-allowed' : 'pointer',
                opacity: !showBothButtons ? 0.6 : 1,
              }}
            >
              Resend Cashless Letter
            </Button>
          </div>
        </SectionContainer>
      </DetailsContainer>
    );
  };

  renderVisionCardInfo = () => {
    const { visionCardInfo } = this.state;

    // Filter only rejected vision cards (those with rejectedReasons)
    const rejectedItems = visionCardInfo.filter(item => item.rejectedReasons);

    // Collect all rejected files (each item has documentUrl as a string)
    const rejectedFiles = rejectedItems.map((item, index) => ({
      url: item.documentUrl,
      name: `Vision Card ${index + 1}`,
      uploadedOn: item.uploadedOn,
      documentType: item.documentType,
      rejectedCount: item.rejectedCount || 0,
      blobUrl: null // Will be set when image loads
    }));

    // Collect all rejected reasons (can be multiple)
    const rejectedReasons = rejectedItems
      .map(item => item.rejectedReasons)
      .filter(reason => reason);

    // Get rejectedCount from API response, default to 0 if not present
    const rejectedCount = visionCardInfo.length > 0 && visionCardInfo[0].rejectionCounts !== undefined
      ? visionCardInfo[0].rejectionCounts
      : 0;

    return (
      <div
        style={{
          display: 'flex',
          gap: '20px',
          padding: '20px',
          height: '100%',
        }}
      >
        {/* Left Side - Rejected Reason and Count */}
        <div
          style={{
            width: '40%',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          {/* Rejected Reason Section */}
          <SectionContainer>
            <SectionHeader
              style={{
                fontSize: '1.2rem',
                marginBottom: '15px',
                color: '#4b4f5b',
              }}
            >
              Rejected Reason{rejectedReasons.length > 1 ? 's' : ''}
            </SectionHeader>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              {rejectedReasons.length > 0 ? (
                rejectedReasons.map((reason, index) => (
                  <div
                    key={index}
                    style={{
                      padding: '12px',
                      backgroundColor: '#FFF3CD',
                      borderRadius: '8px',
                      border: '1px solid #FFE69C',
                      color: '#856404',
                      fontSize: '0.95rem',
                    }}
                  >
                    {rejectedReasons.length > 1 && (
                      <strong style={{ marginRight: '8px' }}>{index + 1}.</strong>
                    )}
                    {reason}
                  </div>
                ))
              ) : (
                <div
                  style={{
                    padding: '12px',
                    backgroundColor: '#D4EDDA',
                    borderRadius: '8px',
                    border: '1px solid #C3E6CB',
                    color: '#155724',
                    fontSize: '0.95rem',
                    textAlign: 'center',
                  }}
                >
                  No rejections
                </div>
              )}
            </div>
          </SectionContainer>

          {/* Rejected Count Section */}
          <SectionContainer>
            <SectionHeader
              style={{
                fontSize: '1.2rem',
                marginBottom: '15px',
                color: '#4b4f5b',
              }}
            >
              Rejected Count
            </SectionHeader>
            <div
              style={{
                padding: '12px',
                backgroundColor: rejectedCount > 0 ? '#F8D7DA' : '#D4EDDA',
                borderRadius: '8px',
                border: rejectedCount > 0 ? '1px solid #F5C6CB' : '1px solid #C3E6CB',
                color: rejectedCount > 0 ? '#721C24' : '#155724',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              {rejectedCount}
            </div>
          </SectionContainer>
        </div>

        {/* Right Side - Rejected Files Display */}
        <div
          style={{
            width: '60%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <SectionHeader
            style={{
              fontSize: '1.2rem',
              marginBottom: '15px',
              color: '#4b4f5b',
            }}
          >
            Rejected Files
          </SectionHeader>
          <div
            style={{
              backgroundColor: '#F8F9FA',
              borderRadius: '8px',
              border: '1px solid #E0E0E0',
              padding: '15px',
              flex: 1,
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gridAutoRows: 'min-content',
                gap: '12px',
                alignContent: 'start',
              }}
            >
              {rejectedFiles.length > 0 ? (
                rejectedFiles.map((file, index) => (
                  <div
                    key={index}
                    onClick={async () => {
                      try {
                        const blobUrl = await getBlobUrl(file.url);
                        window.open(blobUrl, '_blank');
                      } catch (error) {
                        console.error('Error opening file:', error);
                        toast.error('Failed to open file');
                      }
                    }}
                    style={{
                      padding: '10px',
                      backgroundColor: '#FFFFFF',
                      borderRadius: '8px',
                      border: '1px solid #E0E0E0',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '6px',
                      alignItems: 'center',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#E7E3FF';
                      e.currentTarget.style.borderColor = '#714FFF';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 8px rgba(113, 79, 255, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#FFFFFF';
                      e.currentTarget.style.borderColor = '#E0E0E0';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <BlobImage url={file.url} alt={file.name} />
                    <span
                      style={{
                        color: '#4b4f5b',
                        fontWeight: '500',
                        fontSize: '0.75rem',
                        textAlign: 'center',
                        wordBreak: 'break-word',
                        lineHeight: '1.2',
                      }}
                    >
                      {file.name}
                    </span>
                    {file.uploadedOn && (
                      <span
                        style={{
                          fontSize: '0.6rem',
                          color: '#6c757d',
                          textAlign: 'center',
                        }}
                      >
                        {file.uploadedOn}
                      </span>
                    )}
                    <span
                      style={{
                        fontSize: '0.65rem',
                        color: '#714FFF',
                        textAlign: 'center',
                        fontWeight: '500',
                      }}
                    >
                      Click to open
                    </span>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    gridColumn: '1 / -1',
                    padding: '40px',
                    textAlign: 'center',
                    color: '#6c757d',
                  }}
                >
                  <p style={{ fontSize: '1.1rem', marginBottom: '8px' }}>
                    No rejected files
                  </p>
                  <p style={{ fontSize: '0.9rem' }}>
                    All vision cards have been approved
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      callUserLoading,
      activeInfo,
      requestDetails,
      comments,
      loading,
      showConfirmationModal,
      isCallModalOpen,
      callReasonOptions,
      selectedCallReason
    } = this.state;

    const { requestId } = this.props.cashlessVision;

    const renderBasicInfo = () => (
      <DetailsContainer
        style={{
          gap: '60px',
        }}
      >
        <SectionContainer>
          <SectionInnerContainer>
            <SectionHeader
              style={{
                borderBottom: '1px solid #F2F1F6',
                padding: '8px',
              }}
            >
              User Booking Details
            </SectionHeader>
            <SectionBody
              style={{
                paddingTop: '8px',
              }}
            >
              <DetailRow>
                <DetailName>User Id:</DetailName>
                <DetailText>
                  {requestDetails.userId || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Request Id:</DetailName>
                <DetailText>
                  {requestDetails.requestId || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Lenskart Order Id:</DetailName>
                <DetailText>
                  {requestDetails.lenkskartOrderId || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Order Date:</DetailName>
                <DetailText>
                  {requestDetails.orderDate || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Vision Card Date:</DetailName>
                <DetailText>
                  {requestDetails.visionCardDate || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Patient Name:</DetailName>
                <DetailText>
                  {requestDetails.patientName || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Username:</DetailName>
                <DetailText>
                  {requestDetails.userName || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>User Email:</DetailName>
                <DetailText>
                  {requestDetails.userEmail || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>User Phone:</DetailName>
                {requestDetails.userPhone ? (
                  <CallUserText onClick={this.initiateCall}>
                    {callUserLoading ? (
                      <FaSpinner
                        size={15}
                        style={{ paddingBottom: 2 }}
                        className="icon-spin text-success"
                      />
                    ) : (
                      <FaPhone
                        size={15}
                        style={{ paddingBottom: 2 }}
                        className="text-success"
                      />
                    )}
                    {'  '}
                    {requestDetails.userPhone}
                  </CallUserText>
                ) : (
                  <DetailTextDanger>Unavailable</DetailTextDanger>
                )}
              </DetailRow>
            </SectionBody>
          </SectionInnerContainer>
        </SectionContainer>
      </DetailsContainer>
    );

    const renderCenterInfo = () => (
      <DetailsContainer>
        <SectionContainer>
          <SectionInnerContainer>
            <SectionHeader
              style={{
                borderBottom: '1px solid #F2F1F6',
                padding: '8px',
              }}
            >
              Center Details
            </SectionHeader>
            <SectionBody
              style={{
                paddingTop: '8px',
              }}
            >
              <DetailRow>
                <DetailName>Vision Center Id:</DetailName>
                <DetailText>
                  {requestDetails.networkId || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Center Name:</DetailName>
                <DetailText>
                  {requestDetails.centerName || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Center Address:</DetailName>
                <DetailText>
                  {requestDetails.centerAddress || (
                    <DetailTextDanger>Unavailable</DetailTextDanger>
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailName>Center Location:</DetailName>
                {requestDetails.centerLocality ? (
                  <DetailText>
                    {requestDetails.centerLocality}
                  </DetailText>
                ) : (
                  <DetailTextDanger>Unavailable</DetailTextDanger>
                )}
              </DetailRow>
            </SectionBody>
          </SectionInnerContainer>
        </SectionContainer>

        <SectionContainer>
          <SectionInnerContainer
            style={{
              width: '412px',
            }}
          >
            <SectionHeader
              style={{
                borderBottom: '1px solid #F2F1F6',
                justifySelf: 'start',
                padding: '8px',
              }}
            >
              SPOC Details{' '}
            </SectionHeader>
            <SectionBody
              style={{
                paddingTop: '8px',
              }}
            >
              {this.state.spocDetails &&
                this.state.spocDetails.map((spoc) => {
                  return (
                    <SpocDetailContainer
                      style={{
                        border: '1px solid #F2F1F6',
                        borderRadius: '12px',
                        backgroundColor: '#FFFFFF',
                      }}
                    >
                      <DetailRow>
                        <DetailName>Name:</DetailName>
                        <DetailText>{`${spoc.spocName || 'N/A'} (${spoc.spocType || 'N/A'})`}</DetailText>
                      </DetailRow>
                      <DetailRow>
                        <DetailName>Email:</DetailName>
                        <DetailText>{spoc.spocEmail || 'N/A'}</DetailText>
                      </DetailRow>
                      <DetailRow>
                        <DetailName>Phone:</DetailName>
                        <DetailText>{spoc.spocPhone || 'N/A'}</DetailText>
                      </DetailRow>
                    </SpocDetailContainer>
                  );
                })}
            </SectionBody>
          </SectionInnerContainer>
        </SectionContainer>
      </DetailsContainer>
    );

    if (!requestDetails || !requestId) {
      return <LoadingComponent color="black" />;
    }
    if (requestDetails || requestId) {
      return (
        <Container fluid={true}>
          <div className="row">
            <div className="col-12 text-center justify-content-center">
              <ResultToast
                callRequest={this.state.callRequest}
                failRequests={this.state.failRequest}
                successToastMessage={this.state.successToastMessage}
                errorDesc={this.state.errorDesc}
                show={this.state.showToast}
                onToggle={this.toggleToast}
              />
            </div>
          </div>
          <div className="row">
            <ButtonGroup>
              <Button
                style={{
                  width: '144px',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderRight: 'none',
                  backgroundColor: '#FFFFFF',
                  color: activeInfo === 'basic' ? '#714FFF' : '#A5A6BB',
                  boxShadow: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  margin: '0px',
                  borderBottom:
                    activeInfo === 'basic'
                      ? '2px solid #714FFF'
                      : '2px solid #EBEAF5',
                }}
                onClick={() => this.setState({ activeInfo: 'basic' })}
                active={activeInfo === 'basic'}
              >
                Basic Info
              </Button>
              <Button
                style={{
                  width: '144px',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderRight: 'none',
                  backgroundColor: '#FFFFFF',
                  color: activeInfo === 'center' ? '#714FFF' : '#A5A6BB',
                  boxShadow: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  margin: '0px',
                  borderBottom: activeInfo === 'center' ? '2px solid #714FFF' : '2px solid #EBEAF5',
                }}
                onClick={() => this.setState({ activeInfo: 'center' })}
                active={activeInfo === 'center'}
              >
                Center Info
              </Button>
              <Button
                style={{
                  width: '144px',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderRight: 'none',
                  backgroundColor: '#FFFFFF',
                  color: activeInfo === 'payment' ? '#714FFF' : '#A5A6BB',
                  boxShadow: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  margin: '0px',
                  borderBottom: activeInfo === 'payment' ? '2px solid #714FFF' : '2px solid #EBEAF5',
                }}
                onClick={() => this.setState({ activeInfo: 'payment' })}
                active={activeInfo === 'payment'}
              >
                Payment Info
              </Button>
              <Button
                style={{
                  width: '144px',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderRight: 'none',
                  backgroundColor: '#FFFFFF',
                  color: activeInfo === 'action' ? '#714FFF' : '#A5A6BB',
                  boxShadow: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  margin: '0px',
                  borderBottom: activeInfo === 'action' ? '2px solid #714FFF' : '2px solid #EBEAF5',
                }}
                onClick={() => this.setState({ activeInfo: 'action' })}
                active={activeInfo === 'action'}
              >
                Action
              </Button>
              <Button
                style={{
                  width: '160px',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderRight: 'none',
                  backgroundColor: '#FFFFFF',
                  color: activeInfo === 'visionCard' ? '#714FFF' : '#A5A6BB',
                  boxShadow: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  margin: '0px',
                  borderBottom: activeInfo === 'visionCard' ? '2px solid #714FFF' : '2px solid #EBEAF5',
                }}
                onClick={() => this.setState({ activeInfo: 'visionCard' })}
                active={activeInfo === 'visionCard'}
              >
                Vision Card Info
              </Button>
            </ButtonGroup>
          </div>
          <div className="row">
            <div className="col-md-8">
              {activeInfo === 'basic' && renderBasicInfo()}
              {activeInfo === 'center' && renderCenterInfo()}
              {activeInfo === 'payment' && this.renderPaymentInfo()}
              {activeInfo === 'action' && this.renderActionInfo()}
              {activeInfo === 'visionCard' && this.renderVisionCardInfo()}
            </div>
            <div
              className={'mt-2'}
              style={{
                backgroundColor: '#F4F1FF',
                padding: '10px',
                borderRadius: '12px',
                height: '70%',
              }}
            >
              <CommentList loading={loading} comments={comments} />
              <div className="">
                <CommentForm
                  addComment={this.addComment}
                  requestId={requestId}
                />
              </div>
            </div>

          </div>
          <Modal
            isOpen={showConfirmationModal}
            toggle={() => this.setState({ showConfirmationModal: false, isCallModalOpen: false })}
            centered
          >
            <ModalHeader
              toggle={() => this.setState({ showConfirmationModal: false, isCallModalOpen: false })}
              style={{
                borderBottom: '1px solid #E0E0E0',
                padding: '15px 20px'
              }}
            >
              <span style={{
                color: '#714FFF',
                fontSize: '16px',
                fontWeight: '600',
                fontFamily: 'Inter, sans-serif'
              }}>
                Call User
              </span>
            </ModalHeader>
            <ModalBody style={{ padding: '20px' }}>
              {isCallModalOpen && (
                <FormGroup>
                  <Label
                    style={{
                      color: '#0F0B28',
                      fontSize: '14px',
                      fontWeight: '500',
                      fontFamily: 'Inter, sans-serif',
                      marginBottom: '8px'
                    }}
                  >
                    Select Reason for Call
                  </Label>
                  <Input
                    type="select"
                    value={selectedCallReason || ''}
                    onChange={this.handleCallReasonChange}
                    style={{
                      borderRadius: '8px',
                      borderColor: selectedCallReason ? '#714FFF' : '#E0E0E0',
                      color: selectedCallReason ? '#714FFF' : '#495057',
                      padding: '8px 12px',
                      fontSize: '14px',
                      fontFamily: 'Inter, sans-serif'
                    }}
                  >
                    <option value="">Select a reason</option>
                    {callReasonOptions.map((reason, index) => (
                      <option
                        key={index}
                        value={reason}
                        style={{
                          color: '#495057',
                          padding: '8px'
                        }}
                      >
                        {reason}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  marginTop: '20px'
                }}
              >
                <Button
                  onClick={this.submitCall}
                  disabled={callUserLoading || !selectedCallReason}
                  style={{
                    backgroundColor: '#714FFF',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    fontSize: '14px',
                    fontWeight: '600',
                    fontFamily: 'Inter, sans-serif',
                    width: '100px',
                    height: '40px',
                    opacity: selectedCallReason ? '1' : '0.6',
                    cursor: selectedCallReason ? 'pointer' : 'not-allowed'
                  }}
                >
                  Confirm
                </Button>
                <Button
                  onClick={() => this.setState({
                    showConfirmationModal: false,
                    isCallModalOpen: false,
                    selectedCallReason: null,
                    callUserLoading: false
                  })}
                  style={{
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #714FFF',
                    color: '#714FFF',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    fontSize: '14px',
                    fontWeight: '600',
                    fontFamily: 'Inter, sans-serif',
                    width: '100px',
                    height: '40px'
                  }}
                >
                  Cancel
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </Container>
      );
    } else {
      return <div />;
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  cashlessVision: state.cashlessVision,
});

export default connect(mapStateToProps)(RequestDetails);
